import React from 'react';

import { DataBlocks, I18n, Link } from 'components';

const pushWeakPasswordEvent = (action) => () => {
  window.dataLayer.push({
    action,
    event: 'event_cta',
    blockName: 'Надёжен ли ваш пароль?',
  });
};

export const WeakPassword = () => {
  React.useEffect(pushWeakPasswordEvent('show_block'), []);

  return (
    <DataBlocks.Block
      className="attention"
      title={<I18n path="passwordAndAccess.title" />}
      subtitle={(
        <>
          <I18n path="passwordAndAccess.description" />
          <Link
            onClick={pushWeakPasswordEvent('click')}
            href="#/settings/password-and-access"
          >
            <I18n path="passwordAndAccess.linkText" />
          </Link>
        </>
      )}
    />
  );
};
